<template>
    <section class="supervisors">
      <h2 class="section-title">
        Flugleiter
        <span class="material-icons">
          record_voice_over
        </span>
      </h2>
      <div v-if="flightLog.supervisorLogs.length">
        <div v-for="supervisorLog in flightLog.supervisorLogs" :key="supervisorLog.id" class="supervisor-log">
          <div class="supervisor-name">
            {{supervisorLog.user.firstName}} {{supervisorLog.user.lastName}} 
          </div>
 <!--         <img v-if="supervisorLog.user.unlimited"
            class="status-icon"
            src="../assets/Vaccines.svg"
            alt="Test"
          />
          <img v-else
            class="status-icon"
            src="../assets/Vaccines-gray.svg"
            alt="Test"
          /> -->

          <div class="time">
            {{supervisorLog.startTime.substring(11,16)}}
          </div>
          <div class="to">
            -
          </div>
          <div v-if="supervisorLog.endTime" class="time">
            {{supervisorLog.endTime.substring(11,16)}}
          </div>
          <div v-else class="time">--:--</div>
        </div>
      </div>
      <div v-else>
        Heute ist noch kein Flugleiter eingetragen!
      </div>
 
  </section>

</template>

<script>

export default {
    name:'SupervisorPanel',
    props: ['flightLog'],
    emit:['signOutSupervisor']

}
</script>

<style scoped>
 .supervisors {
   background:#fff;
   margin:0;
 }

 .section-title {
   display:inline-block;
   margin: 20px 0;
 }

.supervisor-log {
  border: 2px solid green;
  margin: 8px 8px;
  height: 30px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  background-color: #f5f5f5;
}

.supervisor-name{
  min-width: 110px;
  max-width: 110px;
  padding: 0 0 0 10px;
  text-align: left;
  white-space: nowrap;
  overflow-x: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
}
.status-icon {
  width: 22px;
  height: 22px;
  margin: 0;
  padding: 0px 3px;
  border-right: 1px solid darkgray;

}
.material-icons {
  color:green;
  padding: 0 5px;
}

.time {
  width:50px;
  font-size: 16px;
}

.to {
  width:10px;
  font-weight: bold;
}

</style>